import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { notNullOrEmpty } from '../../utils/common';

const useStyles = makeStyles({ name: 'LabelAndValue' })(theme => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		fontSize: '14px',
		lineHeight: '16px',
		fontWeight: 'bold'
	},
	label: {
		color: theme.palette.text.primary,
		fontWeight: theme.typography.fontWeightLight
	},
	value: {

	}
}));

export type LabelAndValueProps = {
	value: string;
	label?: string;
	classes?: {
		root?: string;
		label?: string;
		value?: string;
	};
};

export const LabelAndValue: React.FC<LabelAndValueProps> = (props) => {
	const { label, value, classes, ...other } = props;
	const { classes: styles } = useStyles(undefined, { props });

	return (
		<div data-test='value-item' className={styles.root} {...other}>
			{notNullOrEmpty(label) &&
				<span data-test='label' className={styles.label}>{label}</span>}
			<span data-test='value' className={styles.value}>{value}</span>
		</div>
	);
};
